/**
 * API接口配置工具函数
 */
import type { ApiEndpoint } from './types';
import type { ApiCategoryGroup, ApiGroup } from "@ms/shared-components/comps/CompsApiList";
import { API_ENDPOINTS } from './index';
import { API_CATEGORIES, API_CATEGORY_GROUPS, CATEGORY_GROUP_MAPPING } from './constants';

/**
 * 根据分类获取接口列表
 */
export const getApisByCategory = (category: string): ApiEndpoint[] => {
  return API_ENDPOINTS.filter((api) => api.category === category);
};

/**
 * 根据ID获取接口详情
 */
export const getApiById = (id: string): ApiEndpoint | undefined => {
  return API_ENDPOINTS.find((api) => api.id === id);
};

/**
 * 获取所有分类
 */
export const getAllCategories = (): string[] => {
  return Object.values(API_CATEGORIES);
};

/**
 * 获取一级分类分组数据
 */
export const getCategoryGroups = (): ApiCategoryGroup[] => {
  // 按一级分类分组
  const groupsByCategoryGroup: Record<string, ApiGroup[]> = {};
  
  // 初始化所有一级分类
  Object.values(API_CATEGORY_GROUPS).forEach(categoryGroup => {
    groupsByCategoryGroup[categoryGroup] = [];
  });
  
  // 将所有二级分类按一级分类分组
  getAllCategories().forEach(category => {
    const categoryGroup = CATEGORY_GROUP_MAPPING[category] || API_CATEGORY_GROUPS.USER_MANAGEMENT;
    const apis = getApisByCategory(category);
    
    if (apis.length > 0) {
      groupsByCategoryGroup[categoryGroup].push({
        category,
        apis: apis.map(api => ({
          id: api.id,
          method: api.method,
          name: api.name,
          path: api.path,
        })),
      });
    }
  });
  
  // 转换为 ApiCategoryGroup 数组，过滤掉空的一级分类
  return Object.entries(groupsByCategoryGroup)
    .filter(([_, groups]) => groups.length > 0)
    .map(([category, groups]) => ({
      category,
      groups,
    }));
};

